






import { defineComponent } from '@vue/composition-api';

const name = 'ttam-material-select-title';

export default defineComponent({
  name,

  props: {
    title: { type: String, default: '' },
  },
});
